export default "__VITE_ASSET__rj9H1SA1__"